import { useState } from 'react';
import { MdContentCopy, MdOutlineCheck } from 'react-icons/md';
import { textAdditionalClassName } from '../../../helpers/utils';

declare const window: WindowTypes;

interface IBtnCopyText {
  text: string;
  additionalClassName?: string;
  iconSize?: number;
  withText?: boolean;
}

const BtnCopyText = ({
  text,
  additionalClassName,
  iconSize = 20,
  withText = true,
}: IBtnCopyText) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyLink = () => {
    if (typeof window !== 'undefined') {
      window?.androidApp?.goToCopyClipboard();
      window?.webkit?.messageHandlers?.iosApp?.postMessage('goToCopyClipboard');
      setIsCopied(true);
      // Cek ketersediaan fitur clipboard sebelum menggunakan
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => setTimeout(() => setIsCopied(false), 2000))
          .catch((error) => console.error('Clipboard writeText error:', error));
      }
    }
  };

  return (
    <button
      className={`flex gap-2 text-sm items-center ${additionalClassName}`}
      onClick={handleCopyLink}
    >
      {withText && <span>SALIN</span>}
      {!isCopied ? (
        <MdContentCopy size={iconSize} color="#CE181E" />
      ) : (
        <MdOutlineCheck size={iconSize} color="#4cc0ad" />
      )}
    </button>
  );
};

export default BtnCopyText;
